import React, { lazy, Suspense, useState } from 'react';
import { motion } from 'framer-motion/dist/framer-motion';
import { TextInput } from '../../../../components';
import { usePolyglot } from '../../../../context/Polyglot';
import ChatSideBarHeader from './children/ChatSideBarHeader';
import ChannelParticipants from './children/ChannelParticipants';
import ChatSettingsMenuOptions from './children/ChatSettingsMenuOptions';
import settingsStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { ChatSettingsSidebarMenus } from '../index';
import { useConversationContext } from '../../../../context/ChatContext/contextConvo';
import LoadingSpinner from '../../../../components/loading/LoadingSpinner';

const ChatHeaderMessagesSearch = lazy(() => import('./children/ChatInnerSearch'));

interface ChatSettingsMenuProps {
    setSideBarTab: (val: ChatSettingsSidebarMenus) => void;
}

export const ChatSettingsMenu: React.FC<ChatSettingsMenuProps> = ({ setSideBarTab }) => {
    const { conversation } = useConversationContext();

    const { t } = usePolyglot();

    const [searchTerm, setSearchTerm] = useState<string>('');

    return (
        <motion.div
            className={settingsStyles.chat_settings_page}
            initial={{
                opacity: 0
            }}
            animate={{
                opacity: 1
            }}
            exit={{
                opacity: 0
            }}
        >
            <ChatSideBarHeader />
            <div className={styles.chat_side_input}>
                <TextInput
                    name='Chat Search'
                    placeholder={t('actions.search_chat')}
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    autoFocus
                    isSearch
                />
            </div>
            {searchTerm ? (
                <Suspense fallback={<LoadingSpinner color='mamba' />}>
                    <ChatHeaderMessagesSearch
                        searchValue={searchTerm}
                    />
                </Suspense>
            ) : (
                <>
                    <ChatSettingsMenuOptions setSideBarTab={setSideBarTab} />
                    {conversation.type === 'channel' && <ChannelParticipants />}
                </>
            )}
        </motion.div>
    );
};
